import { Component, OnInit, Input } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { HttpClient } from "@angular/common/http";
import { environment } from "./../../../../../environments/environment";
import { OpAdminProductListService } from "src/app/views/common/services/op-admin-product-list.service";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-vidio-dialog",
  templateUrl: "./vidio-dialog.component.html",
  styleUrls: ["./vidio-dialog.component.css"],
})
export class VidioDialogComponent implements OnInit {
  myVideo: any = [];
  productDetial: any = [];

  @Input() title: string;
  @Input() message: string;
  @Input() btnOkText: string;
  @Input() btnCancelText: string;
  @Input() productId: string;
  @Input() storeType: string;

  is360 = false;
  isZoomImage = false;
  isVideoUrl = true;

  constructor(
    private activeModal: NgbActiveModal,
    public _sanitize: DomSanitizer,
    private http: HttpClient,
    private activeRoute: ActivatedRoute,
    private productListService: OpAdminProductListService,
    public _DomSanitizationService: DomSanitizer
  ) {}

  ngOnInit() {
    this.productListService
      .getImagesByProduct(
        this.productId,
        this.storeType,
        this.is360,
        this.isZoomImage,
        this.isVideoUrl
      )
      .subscribe(
        (response: any) => {
          this.myVideo = response.data;
        },
        (err: any) => {
          console.error(err);
        }
      );
  }
  public decline() {
    this.activeModal.close(false);
  }

  public accept() {
    this.activeModal.close(true);
  }

  public dismiss() {
    this.activeModal.dismiss();
  }
}
